<template>
  <div class="dialog-wap">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      title=""
      :before-close="handleClose"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            下载回单
          </h4>
        </div>
      </template>
      <el-table ref="downloadTable" v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData" :cell-style="initOperatorColumnStyle">
        <el-table-column align="center" type="selection" :min-width="55" />
        <el-table-column align="center" prop="orderNo" label="关联订单" :min-width="180" />
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            :loading="saveBtnLoading" @click="handleClose"
          >
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { initOperatorColumnStyle } from '@vue3/components';
import { queryDutyAcceptPackageDownloadReceipt, queryPersonOrderList } from '@core/main/api/crowd-source/task-accept-package';
import { ElMessage } from 'element-plus';
import { PropType, ref, watch } from 'vue';
import { IDutyAcceptPackage, IPersonOrderItem } from '@core/main/types';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IDutyAcceptPackage>,
    default: () => {},
  },
});

const emit = defineEmits<{close: []}>();

const saveBtnLoading = ref(false);
const loading = ref(false);

const tableData = ref<IPersonOrderItem[]>([]);
const orderDetailIds = ref<number[]>([]);
const downloadTable = ref();

async function handleSubmit() {
  const orderDetails = downloadTable.value.getSelectionRows();

  orderDetailIds.value = orderDetails.map((v) => v.orderDetailId);
  if (orderDetailIds.value.length <= 0) {
    ElMessage.error('请选择需要下载回单的订单');
    return;
  }

  try {
    const url = await queryDutyAcceptPackageDownloadReceipt({
      orderDetailIds: orderDetailIds.value,
      personName: props.row.personName,
    });

    window.open(url);
    handleClose();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function handleClose() {
  tableData.value = [];
  orderDetailIds.value = [];
  emit('close');
}

async function fetchData(personIdNumber: string, dutyId: number) {
  try {
    tableData.value = await queryPersonOrderList(personIdNumber, dutyId);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

watch(
  () => props.visible,
  () => {
    if (props.visible && props.row) {
      fetchData(props.row.personIdNumber, props.row.dutyId);
    }
  },
);

</script>

<style lang="scss" scoped>

</style>
